import { useRef, MouseEvent, useState, useEffect } from "react";
import { Redirect, useHistory } from "react-router";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../context-store";
import AppConfig from "../../config";
import RegisterParams from "../../models/common/PageParms";
import IdNameModel from "../../models/common/IdNameModel";
import RegisterService from "../../services/authentication-service";
import RegisterUserModel from "../../models/authentication/RegisterUser";
import { OBJECT_NAME_RULE, EMAIL_RULE, PASSWORD_RULE, MOBILE_NUMBER_RULE, FORM_SELECT_RULE } from "../../utils/validation-utils";
import { Controller, useForm } from "react-hook-form";
import masterDataService from '../../services/master-data-service';
import EncryptUtil from '../../utils/encode-utils';
import { RoleEnum } from "../../models/enums/RoleEnum";
import ReCAPTCHA from "react-google-recaptcha";
import CompanyLogo from "../../assets/img/logos/employer.png";
import InterviewerLogo from "../../assets/img/logos/interviewer.png";
import toasterUtils from "../../utils/toaster-utils";
import modalUtils from "../../utils/modal-utils";
import { TextField, Select, MenuItem, Button, FormControl, InputLabel, FormHelperText, Autocomplete } from "@mui/material";
import NavigateNextOutlinedIcon from '@mui/icons-material/NavigateNextOutlined';
const RegisterCom = () => {
    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
        reset,
        control
    } = useForm<RegisterUserModel>({
        mode: "onChange",
    });
    const [primarySkill, setPrimarySkill] = useState<IdNameModel[]>([]);
    const [country, setCountry] = useState<IdNameModel[]>([]);
    const [city, setCity] = useState<IdNameModel[]>([]);
    const [experience, setExperience] = useState<IdNameModel[]>([]);
    const captchaRef: any = useRef(null);
    const siteKey = AppConfig.envVariables.recapchaSiteKey;
    useEffect(() => {
        getPrimarySkill();
        getCountry();
        getExperience();
    }, [])
    const requestParams: RegisterParams = useParams();
    const history = useHistory();
    const authenticated = useAppSelector(
        (state: any) => state.authState.authenticated
    );

    if (authenticated) {
        return <Redirect to="/"></Redirect>;
    };

    const signIn = (event: MouseEvent) => {
        event.preventDefault();
        history.push("/login");
    };

    const fnRegister = (event: MouseEvent, registerType: string) => {
        event.preventDefault();
        history.push("/register/" + registerType);
    }

    const onSubmit = (registerFormData: RegisterUserModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        const token = captchaRef.current.getValue();
        captchaRef.current.reset();
        if (token === null || token === '') {
            toasterUtils.showWarning("Please accept captcha.");
            return;
        }
        registerFormData.password = EncryptUtil.getEncoded(registerFormData.password);
        registerFormData.confirmPassword = EncryptUtil.getEncoded(registerFormData.confirmPassword);
        if (registerFormData.password != registerFormData.confirmPassword) {
            toasterUtils.showError("passwords doesn't match.");
        } else {
            registerFormData.mobileNumber = Number(registerFormData.mobileNumber);
            registerFormData.primarySkillId = Number(registerFormData.primarySkillId);
            registerFormData.countryId = Number(registerFormData.countryId);
            registerFormData.cityId = Number(registerFormData.cityId);
            registerFormData.experienceId = Number(registerFormData.experienceId);
            registerFormData.roleId = requestParams.type === "Candidate" ? Number(RoleEnum.Candidate) : Number(RoleEnum.Interviewer);
            registerFormData.emailId = registerFormData.userName;
            modalUtils.showLoader();
            RegisterService.registerUser(registerFormData).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                toasterUtils.showSuccess(res.informationMessages.toString());
                setTimeout(() => {
                    history.push("/login");
                }, 1000);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError("Erorr registering user.");
            });
        }
    };

    const getPrimarySkill = () => {
        modalUtils.showLoader();
        masterDataService.loadPrimarySkills().then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setPrimarySkill(res.items);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Primary skills");
        });
    };

    const getCountry = () => {
        masterDataService.loadCountries().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCountry(res.items);
        }).catch((error) => {
            toasterUtils.showError("Unable to load Countries");
        });
    };

    const getExperience = () => {
        masterDataService.loadExperiences().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setExperience(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getCity = (targetValue: number) => {
        modalUtils.showLoader();
        masterDataService.loadCities(targetValue).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCity(res.items);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const clearForm = () => {
        reset({
            name: "",
            userName: "",
            password: "",
            confirmPassword: "",
            mobileNumber: 0,
            primarySkillId: 0,
            countryId: 0,
            cityId: 0,
            experienceId: 0,
        });
    };

    return (
        <section className="bg-light md">
            <div className="container-body">
                <div className="row">
                    <div className="col-lg-6 badge-mobile-view">
                        <div className="row">
                            <div className="col-lg-3 col-md-3 badgeRating-login">
                                {/* <h1>{props.objRatingDetails.totalRating}/{IAIEnum.MaxRating}</h1> */}
                                <h1>4.5/5</h1>
                            </div>
                            <div className="col-lg-7 col-md-7 badgeBody-login">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 badgeRatingDetails-login">
                                        {/* <h1>{props.objRatingDetails.candidateName}</h1> */}
                                        <h1>Jahangir A</h1>
                                        {/* <h2>ID: <span>{props.objRatingDetails.interviewUniqueId}</span></h2> */}
                                        <h2>ID: <span>999999999999</span></h2>
                                        {/* <p>Primary Skill: <span>{props.objRatingDetails.primarySkillName}</span></p> */}
                                        <p>Primary Skill: <span>Full Stack Developer</span></p>
                                    </div>
                                    <div className="col-lg-6 col-md-6 badgeRatingDetails-login">
                                        <p>Secondary Skill:</p>
                                        {/* <p>
                                                                {props.objRatingDetails.technicalSkillRating.map((field, index) => (
                                                                    <span className="sec-skill">
                                                                        {field.secondarySkillName} : <span className="badgeSecSkillRating">{field.rating}</span>
                                                                    </span>
                                                                ))}
                                                            </p> */}
                                        <p>Html, Css, Javascript, React, Figma, Design System</p>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-lg-6 col-md-6 text-end">
                                        <p className="badgeVeryFy">Verify at www.iaminterviewed.com </p>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="badgeLogo-login"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-2 badgeTail-login">
                            </div>

                            <div className="col-lg-12">
                                <div className="contact-form-box mh-note">
                                    <p>Please Note:</p>
                                    <div className="register-note-login">
                                        <ul>
                                            <li><NavigateNextOutlinedIcon />Your profile is secured</li>
                                            <li><NavigateNextOutlinedIcon />No one can see your contact details. You MUST grant Access to each of the request for any employer to see your contact details</li>
                                            <li><NavigateNextOutlinedIcon />You can Apply to your favorite companies</li>
                                            <li><NavigateNextOutlinedIcon />You will receive your Technical Skill Badge after Interview, you can use this badge to apply for any company</li>
                                        </ul>
                                    </div>
                                    <div className="quote-login">
                                        <p>"Perseverance is the hard work you do after you get tired of doing the hard work you already did."</p>
                                        <p className="quote-login-author">-- Newt Gingrich</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="container-body">
                            <div className="contact-form-box mh-690">
                                <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="quform-elements">
                                        <div className="row">
                                            <div className="col-md-12">
                                                 <h2 className="section-title">Sign up as {requestParams.type}</h2>
                                            </div>
                                           
                                            <div className="col-md-6">
                                                <FormControl fullWidth margin="normal" error={!!errors.name}>
                                                    <TextField label={`${requestParams.type === "Candidate" ? "Candidate" : "Interviewer"} Name`} size="small" {...register("name", OBJECT_NAME_RULE)} error={!!errors.name}
                                                        helperText={errors.name?.message} autoComplete="off" required sx={{ backgroundColor: "white" }} />
                                                </FormControl>
                                            </div>
                                            <div className="col-md-6">
                                                <FormControl fullWidth margin="normal" error={!!errors.userName}>
                                                    <TextField type="Email" label="Email/User Name" size="small" {...register("userName", EMAIL_RULE)} error={!!errors.userName}
                                                        helperText={errors.userName?.message} autoComplete="off" required sx={{ backgroundColor: "white" }} />
                                                </FormControl>
                                            </div>
                                            <div className="col-md-6">
                                                <FormControl fullWidth margin="normal" error={!!errors.password}>
                                                    <TextField type="password" label="Password" size="small" {...register("password", PASSWORD_RULE)} error={!!errors.password}
                                                        helperText={errors.password?.message} autoComplete="off" required sx={{ backgroundColor: "white" }} />
                                                </FormControl>
                                            </div>
                                            <div className="col-md-6">
                                                <FormControl fullWidth margin="normal" error={!!errors.confirmPassword}>
                                                    <TextField type="password" label="Confirm Password" size="small" {...register("confirmPassword", PASSWORD_RULE)} error={!!errors.confirmPassword}
                                                        helperText={errors.confirmPassword?.message} autoComplete="off" required sx={{ backgroundColor: "white" }} />
                                                </FormControl>
                                            </div>
                                            <div className="col-md-6">
                                                <FormControl fullWidth margin="normal" error={!!errors.mobileNumber}>
                                                    <TextField type="text" label="Mobile Number" size="small" {...register("mobileNumber", MOBILE_NUMBER_RULE)} error={!!errors.mobileNumber}
                                                        helperText={errors.mobileNumber?.message} autoComplete="off" required sx={{ backgroundColor: "white" }} />
                                                </FormControl>
                                            </div>
                                            <div className="col-md-6">
                                                <Controller name="primarySkillId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                                    render={({ field }) => (
                                                        <Autocomplete {...field} value={primarySkill.find(x => x.id === field.value) || null}
                                                            onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={primarySkill} getOptionLabel={(option) => option.name || ""}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label="Primary Skill" size="small" required margin="normal" fullWidth error={!!errors.primarySkillId} helperText={errors.primarySkillId?.message} sx={{ backgroundColor: "white" }} />
                                                            )}
                                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <Controller name="countryId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                                    render={({ field }) => (
                                                        <Autocomplete {...field} value={country.find(x => x.id === field.value) || null}
                                                            onChange={(_, newValue) => { field.onChange(newValue ? newValue.id : 0); getCity(newValue ? newValue.id : 0); }} options={country} getOptionLabel={(option) => option.name || ""}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label="Country" size="small" required margin="normal" fullWidth error={!!errors.countryId} helperText={errors.countryId?.message} sx={{ backgroundColor: "white" }} />
                                                            )}
                                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <Controller name="cityId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                                    render={({ field }) => (
                                                        <Autocomplete {...field} value={city.find(x => x.id === field.value) || null}
                                                            onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={city} getOptionLabel={(option) => option.name || ""}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label="City" size="small" required margin="normal" fullWidth error={!!errors.cityId} helperText={errors.cityId?.message} sx={{ backgroundColor: "white" }} />
                                                            )}
                                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <Controller name="experienceId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                                    render={({ field }) => (
                                                        <Autocomplete {...field} value={experience.find(x => x.id === field.value) || null}
                                                            onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={experience} getOptionLabel={(option) => option.name || ""}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label="Experience" size="small" required margin="normal" fullWidth error={!!errors.experienceId} helperText={errors.experienceId?.message} sx={{ backgroundColor: "white" }} />
                                                            )}
                                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className="col-lg-12 col-md-12">
                                                <div className="quform-element form-group">
                                                    <div className="quform-input">
                                                        <ReCAPTCHA sitekey={siteKey} ref={captchaRef} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-7 register-block-btns">
                                                <Button variant="contained" color="primary" type="submit" size="large" sx={{ mt: 3 }}>
                                                    Register
                                                </Button>
                                                <Button variant="contained" color="inherit" className="m-l-xxs" size="large" type="button"
                                                    onClick={clearForm} sx={{ mt: 3, color: "#898989", backgroundColor: "#d1d1d1" }}>
                                                    Cancel
                                                </Button>
                                            </div>
                                            <div className="col-md-5 text-end">
                                                <span className="sign-in-question" ><a onClick={(e) => { signIn(e); }}>Already Registered ? Sign in</a></span>
                                            </div>
                                            <div className="signup-different-user">
                                                <p className="login-title">Sign up as</p>
                                                <div className="row">
                                                    {requestParams.type === 'Candidate' &&
                                                        <div className="col-lg-6 col-md-6 signup-different-options">
                                                            <img src={InterviewerLogo} alt="" />
                                                            <h3><a onClick={(e) => { fnRegister(e, "Interviewer"); }}>Interviewer</a></h3>
                                                        </div>
                                                    }
                                                    {requestParams.type === 'Interviewer' &&
                                                        <div className="col-lg-6 col-md-6 signup-different-options">
                                                            <img src={InterviewerLogo} alt="" />
                                                            <h3><a onClick={(e) => { fnRegister(e, "Candidate"); }}>Candidate</a></h3>
                                                        </div>
                                                    }
                                                    <div className="col-lg-6 col-md-6 signup-different-options" >
                                                        <img src={CompanyLogo} alt="" />
                                                        <h3><a onClick={(e) => { fnRegister(e, "Company"); }}>Employer</a></h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default RegisterCom;